import styled from "styled-components";

export const OwnerBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;
